<div  class="file-explorer">
  <!-- <div  class="file-explorer"> -->
  <!-- HEADER -->
  <div class="header">
    <ul class="nav">
      <li class="nav-item" (click)="goToRacine()" title="{{'FILE_EXPLORER.ALLER_RACINE' | translate }}">
        <a class="nav-link"><i class="fas fa-level-up-alt"></i></a>
      </li>
      <li class="nav-item" (click)="goToParent(racineLocal)" title="{{'FILE_EXPLORER.ALLER_DOSSIER_PARENT' | translate }}">
        <a class="nav-link"><i class="fas fa-arrow-left"></i></a>
      </li>
      @if (showIcon && clientReadWrite()) {
        <li class="nav-item" (click)="fileInput.click()" title="{{'FILE_EXPLORER.AJOUTER_FICHIERS' | translate }}">
          <div id="fileT" style="overflow: hidden; position: relative; width: 0; height: 0;">
            <input type="file" accept="*/*" #fileInput [hidden]="true" multiple (change)="filesFromInput($event)">
          </div>
          <a class="nav-link"><i class="fas fa-file-medical"></i></a>
        </li>
      }
      @if (showIcon && clientReadWrite()) {
        <li class="nav-item" (click)="openModalCreerDossier()" title="{{'FILE_EXPLORER.CREATION_DOSSIER' | translate }}">
          <a class="nav-link"><i class="fas fa-folder-plus"></i></a>
        </li>
      }
      @if (!reverseOrder) {
        <li class="nav-item" (click)="tri()" title="{{'FILE_EXPLORER.ORDRE_ALPHA_ASC' | translate }}">
          <a class="nav-link"><i class="fas fa-sort-alpha-down"></i></a>
        </li>
      }
      @if (reverseOrder) {
        <li class="nav-item" (click)="tri()" title="{{'FILE_EXPLORER.ORDRE_ALPHA_DEC' | translate }}">
          <a class="nav-link"><i class="fas fa-sort-alpha-up"></i></a>
        </li>
      }
      @if (showIcon && clientReadWrite()) {
        <li class="nav-item" (click)="selectAll()" title="{{'FILE_EXPLORER.TOUT_SELECTIONNER' | translate }}">
          <a class="nav-link"><i class="fas fa-th"></i></a>
        </li>
      }
      <!-- Boutons affichés conditionnellement -->
      @if (((selectedFolders.length == 1 && selectedFiles.length == 0) || (selectedFolders.length == 0 && selectedFiles.length == 1) && clientReadWrite())) {
        <li class="nav-item" (click)="openModalRenommer()"
          title="{{'FILE_EXPLORER.RENOMMER' | translate }}">
          <a class="nav-link"><i class="fas fa-pen"></i></a>
        </li>
      }
      @if (selectedFolders.length > 0 || selectedFiles.length > 0) {
        <li class="nav-item" (click)="telecharger()" title="{{'FILE_EXPLORER.TELECHARGER' | translate }}">
          <a class="nav-link"><i class="fas fa-download"></i></a>
        </li>
      }
      @if (selectedFiles.length > 0 && clientReadWrite()) {
        <li class="nav-item" (click)="couper()" title="{{'FILE_EXPLORER.COUPER' | translate }}">
          <a class="nav-link"><i class="fas fa-cut"></i></a>
        </li>
      }
      @if (pressePapier.length > 0 && couperEncours && clientReadWrite()) {
        <li class="nav-item" (click)="coller()" title="{{'FILE_EXPLORER.COLLER' | translate }}">
          <a class="nav-link"><i class="fas fa-paste"></i></a>
        </li>
      }
      @if ((selectedFolders.length > 0 || selectedFiles.length > 0) && clientReadWrite()) {
        <li class="nav-item" (click)="modalConfirmSuppr.show()" title="{{'FILE_EXPLORER.SUPPRIMER_FICHIERS' | translate }}">
          <a class="nav-link"><i class="far fa-trash-alt"></i></a>
        </li>
      }
      @if (((selectedFiles.length > 0 || selectedFolders.length > 0) || couperEncours) && clientReadWrite() ) {
        <li class="nav-item" (click)="cancelColler()" title="{{'GLOBAL.ANNULER' | translate }}">
          <a class="nav-link"><i class="fas fa-times"></i></a>
        </li>
      }
    </ul>
    <div class="path">
      <div class="text-path">@for (ele of path; track ele) {
        <span>{{ele}}/</span>
      }</div>
    </div>
  </div>

  <div class="table noselect "
    id="explorer-content"
    (drop)="filesFromDrop($event)"
    (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)"
    (dragend)="onDragEnd($event)"
    (dragover)="dragOverContent($event)"
    >
    <div class="table-box">
      <table>
        <thead>
          <tr>
            <th width="3%" style="width: 25px;"></th>
            @for (propriete of proprietesAffichees; track propriete; let i = $index) {
              <th width="{{table_Width[i] + '%' }}">
                <div  style="cursor: pointer" (click)="sortTable(propriete.nom)" (keyup)="onKeyUp($event, propriete.nom)">
                  <span>{{ propriete.libelleAffiche | translate }}</span>
                  @if (sortColumn === propriete.nom) {
                    <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                      [ngStyle]="{'width': '16px', 'height': '16px'}" [alt]="sortOrder ? 'asc' : 'desc'" />
                  }
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody >
          @for (d of dossierCourant.sousDossiers; track d; let i = $index) {
            <tr (dblclick)="enterFolder(d)"   (click)="selectFolder($event, d)"   >
              <td style="padding-right: 0;padding-left: 11px;" ><input style="accent-color: #7E003F;"   type="checkbox" [checked]="d.isSelected" ></td>
              <td [title]="d.nom" style="color:#7E003F;"><b>{{ d.nom | uppercase  }}</b></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          }
          @for (f of dossierCourant.fichiers; track f; let i = $index) {
            <tr  (click)="selectFile($event, f)"    [class.cutting]="couperEncours && f.isSelected"  >
              <td  style="padding-right: 0;padding-left: 11px;"   width="10%"><input style="accent-color: #7E003F;cursor: pointer;" type="checkbox" [checked]="f.isSelected"  ></td>
              <td [title]="removeExtension(f.nom)">{{ removeExtension(f.nom) }} @if (checkIfFileCanBePreview(f)) {
                <i class="fas fa-eye icon-prev"  (click)="openFileInNewWindow(f, $event)" ></i>
              }</td>
              <td [title]="getFileExtension(f.nom)">{{ getFileExtension(f.nom) }}</td>
              <td [title]="f.taille">{{ bytesToMb(f.taille) }}Mb</td>
              <td [title]="f.dateCreation">{{ f.dateCreation | date:'dd/MM/yyy HH:mm:ss' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>

  <div class="footer d-flex align-items-center">
    <!-- Cas 1 fichier-->
    @if (selectedFiles.length == 1 && selectedFolders.length == 0) {
      <div>
        {{'GLOBAL.FICHIER' | translate}} : {{selectedFiles[0].nom}}, {{'GLOBAL.TAILLE' | translate}} : {{poidsTotal | formatFileSize}}, {{'GLOBAL.DATE_CREATION' | translate}} : {{selectedFiles[0].dateCreation | date: 'dd/MM/yyyy, h:mm'}}
      </div>
    }
    <!-- Cas 1 dossier -->
    @if (selectedFiles.length == 0 && selectedFolders.length == 1) {
      {{'FILE_EXPLORER.REPERTOIRE' | translate}} : {{selectedFolders[0].nom}}, {{'GLOBAL.TAILLE' | translate }} : {{poidsTotal | formatFileSize }}
    }
    <!-- Cas 1+ fichier et/ou 1+ dossier -->
    @if (!(selectedFiles.length == 1 && selectedFolders.length == 0) && !(selectedFiles.length == 0 && selectedFolders.length == 1) && (selectedFiles.length != 0
      || selectedFolders.length != 0)) {
      @if (selectedFiles.length > 0) {
        {{selectedFiles.length}} {{'FILE_EXPLORER.FICHIER_SELECTIONNE' | translate }},
      }
      @if (selectedFolders.length > 0) {
        {{selectedFolders.length}} {{'FILE_EXPLORER.REPERTOIRE_SELECTIONNE' | translate }},
      }
      {{'GLOBAL.TAILLE_TOTAL' | translate }} : {{poidsTotal | formatFileSize}}
    }
    <!-- Cas 0 fichier et 0 dossier -->
    @if (selectedFiles.length == 0 && selectedFolders.length == 0) {
      @if (dossierCourant.fichiers && dossierCourant.fichiers.length == 1) {
        {{dossierCourant.fichiers.length}} {{'GLOBAL.FICHIER' | translate | lowercase}},
      }
      @if (dossierCourant.fichiers && dossierCourant.fichiers.length > 1) {
        {{dossierCourant.fichiers.length}} {{'GLOBAL.FICHIERS' | translate | lowercase }},
      }
      @if (dossierCourant.sousDossiers && dossierCourant.sousDossiers.length == 1) {
        {{dossierCourant.sousDossiers.length}} {{'FILE_EXPLORER.REPERTOIRE' | translate | lowercase}},
      }
      @if (dossierCourant.sousDossiers && dossierCourant.sousDossiers.length > 1) {
        {{dossierCourant.sousDossiers.length}} {{'FILE_EXPLORER.REPERTOIRES' | translate | lowercase}},
      }
      <ng-container>
        {{'GLOBAL.TAILLE_TOTAL' | translate }} : {{poidsTotal | formatFileSize}}
      </ng-container>
    }
  </div>
</div>

<div bsModal #modalFormDossier="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{'FILE_EXPLORER.AJOUT_DOSSIER' | translate}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalFormDossier.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="addFolder($event)">
          <div class="form-group">
            <label for="nomDossier">{{'GLOBAL.NOM' | translate}}</label>
            <input type="text" class="form-control" name="nomDossier" id="nomDossier" maxlength="50" />
            @if (dossierErreurNom) {
              <div class="custom-alert custom-alert-sm" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate" style="white-space: pre-line;"></div>
            }
            @if (dossierNomRequis) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
            }
            @if (nomDossierExistant) {
              <div class="custom-alert custom-alert-sm">{{'FILE_EXPLORER.DOSSIER_EXISTANT' | translate }}</div>
            }
          </div>
          <div class="btn-toolbar justify-content-between">
            <div class="btn-group" role="group">
              <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
            </div>
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-secondary" (click)="modalFormDossier.hide()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalRenommer="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{'FILE_EXPLORER.RENOMMER' | translate}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRenommer.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="renommer($event)">
          <div class="form-group">
            <label for="nvNom">{{'GLOBAL.NOM' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="nvNom" name="nvNom" id="nvNom" maxlength="50" />
            @if (renommageErreurNom) {
              <div class="custom-alert custom-alert-sm" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate" style="white-space: pre-line;"></div>
            }
            @if (renommageNomRequis) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
            }
          </div>
          <div class="btn-toolbar justify-content-between">
            <div class="btn-group" role="group">
              <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
            </div>
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-secondary" (click)="modalRenommer.hide()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center">
        @if (selectedFiles && (selectedFiles.length == 1 && selectedFolders.length == 0) || (selectedFiles.length == 0 && selectedFolders.length == 1)) {
          <div>
            <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
          </div>
        }
        @if (selectedFiles && (selectedFiles.length > 1 || selectedFolders.length > 1 || (selectedFiles.length == 1 && selectedFolders.length == 1))) {
          <div>
            <p>{{'FILE_EXPLORER.CONFIRMATION_SUPPRESSION_MULTIPLE' | translate}}</p>
          </div>
        }
        <button type="button" class="btn btn-primary" (click)="deleteItems()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalConfirmSuppr.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmUpload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{'FILE_EXPLORER.AJOUT_FICHIERS' | translate}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRenommer.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        @if (files && files.length == 1) {
          <p style="word-break: break-all;">{{'FILE_EXPLORER.MESSAGE_FICHIER_UNIQUE' | translate:{nomFichier: files[0].name} }}</p>
        }
        @if (files && files.length > 1) {
          <p>{{'FILE_EXPLORER.MESSAGE_FICHIERS_MULTIPLE' | translate}}</p>
          <ul id="files-list">
            @for (file of files; track file) {
              <li style="word-break: break-all;">{{file.name}} ({{file.size | formatFileSize}} )</li>
            }
          </ul>
        }
        <p><b>{{'GLOBAL.TAILLE_TOTAL' | translate}} :</b> {{totalSize | formatFileSize}}</p>
        @if (warningDuplicateFile) {
          <div class="alert alert-warning" role="alert">
            {{'GLOBAL.WARNING_FILE_DUPLICATE' | translate}}
          </div>
        }
        <div class="text-center">
          @if (files && files.length == 1) {
            <p>{{'FILE_EXPLORER.CONFIRM_UPLOAD_UNIQUE' | translate }}</p>
          }
          @if (files && files.length > 1) {
            <p>{{'FILE_EXPLORER.CONFIRM_UPLOAD_MULTIPLE' | translate}}</p>
          }
          <button type="button" class="btn btn-primary" (click)="uploadFiles(files)">{{'GLOBAL.OUI' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="hideModalConfirmUpload()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalUpload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TRANSFERT' | translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="text-center">{{'FILE_EXPLORER.AVANCEMENT' | translate}} : {{ progress + ' %' }}</div>
        <div class="progressbar-overlay">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" id="progressbar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalDownload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TELECHARGEMENT' | translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="text-center not-selectable">{{'FILE_EXPLORER.PREPARATION_TELECHARGEMENT' | translate}}</div>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalFichiersSupprimes="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TELECHARGEMENT' | translate}}</h4>
      </div>
      <div class="modal-body text-center">
        <div class="text-center not-selectable">{{'FILE_EXPLORER.CONFIRM_SUPPR_REF_MORTES' | translate}}</div>
        <button type="button" class="btn btn-primary" (click)="supprimerReferencesMortes()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalFichiersSupprimes.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalErreurSynchro="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{estErreurRenommage ? ('FILE_EXPLORER.RENOMMER' | translate) : ('FILE_EXPLORER.DEPLACEMENT' | translate)}}</h4>
      </div>
      <div class="modal-body text-center">
        <div class="text-center not-selectable">{{estErreurRenommage ? ('FILE_EXPLORER.FICHIER_RENOMME_SUPPR' | translate) : ('FILE_EXPLORER.REP_DEST_SUPPR' | translate)}}</div>
        <button type="button" class="btn btn-primary" (click)="modalErreurSynchro.hide()">{{'GLOBAL.OK' | translate}}</button>
      </div>
    </div>
  </div>
</div>
